import { isNative } from '../../lib/platform.js';

/**
 * Live pronunciation assessment of the conversation («Análisis fonético»: the
 * `phonetic` pref, which also plugs the PA provider into the voice session — see
 * `startModuleHints.ts`) is a beta feature offered ONLY on the web. The native
 * builds (iOS/Android) neither show its toggle nor send audio to the PA
 * provider: the AI data consent mentions pronunciation only conditionally, and
 * the store listings must not depend on a feature that will probably go away.
 *
 * On native, `useConversationSettings` runs every session with `phonetic: false`
 * while keeping the persisted pref untouched (a learner who turned it on on the
 * web keeps it there). With it off, no phonetic corrections reach the UI, so the
 * pronunciation drill (`DrillModal`, `POST /pa-practice`) is unreachable too.
 */
export const LIVE_PA_AVAILABLE: boolean = !isNative;
